module.exports = __webpack_public_path__ + "img/3.c72d433d.png";